var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({class:['input-group', _vm.sizeClass],attrs:{"role":"group"}},'div',_vm.$attrs,false),_vm.$listeners),[_vm._t("prepend"),_vm._t("default"),_vm._t("append")],2)}
var staticRenderFns = []

export { render, staticRenderFns }